import { render, staticRenderFns } from "./ZhanhuiHome.vue?vue&type=template&id=b941a576&scoped=true"
import script from "./ZhanhuiHome.vue?vue&type=script&lang=js"
export * from "./ZhanhuiHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b941a576",
  null
  
)

export default component.exports